<template>
              <!-- =============== SECTION ITEMS =============== -->
    <section  class="padding-top-sm background-cwb ">

    <header class="section-heading ">
        <h4 class=" text-uppercase ">{{linhaProdutos}}</h4>
    </header>

    <div class="row row-sm">

        <div class="col-xl-3 col-lg-3 col-md-4 col-6 "
        
        v-show='!Loading'
        v-for="product in arrayProduct" :key="product.id"
        >
            
            <ProductCard
            :ProductImg='product.img1'
            :ProductId='product.id'
            :ProductDescricao='product.descricao.nome'
            :ProductFabricante='product.fabricante.nome'
            :ProductPreco='product.precoVenda'
            :ProductObj='product'
            :UserId='UserId'
            />



        </div> <!-- col.// -->


        <div class="col-12  m-auto "  v-show='NotProduct === true'>
            <article class="card card-body bg-transparent">
                <figure class="text-center">
              
                    <figcaption class="pt-4">
                    <h5 class="title">Não encontramos nenhum produto.</h5>
                    <p class=''>Escolha outra categoria </p>
                    </figcaption>

                         <img
                            class=' m-auto'
                            :src='NotProductImg'
                           
                            />
    
                </figure> <!-- iconbox // -->
            </article> <!-- panel-lg.// -->
        </div><!-- col // -->


        <Skeleton
        :Loading='Loading'
        />

        <Skeleton
        :Loading='Loading'
        />
        <Skeleton
        :Loading='Loading'
        />
        <Skeleton
        :Loading='Loading'
        />
        <Skeleton
        :Loading='Loading'
        />
        <Skeleton
        :Loading='Loading'
        />


        
       
    </div> <!-- row.// -->
    </section>
    <!-- =============== SECTION ITEMS .//END =============== -->
</template>

<script>
import ProductCard from './ProductCardColecao'
import Skeleton from '../../components/Load/Skeleton'
import NotProductImg from '../../assets/img/no-product.svg'
import {formatPrice} from '../../tools/formatPrice'
import {mapActions} from 'vuex'

    export default {
        props: {
            arrayProduct: {
                type: Array,
            },
            linhaProdutos: {
                type: String,
            },
            Loading: {
                type:Boolean
            },
            NotProduct: {
                type:Boolean,
            },
            ChoicedProdut: {
                type:Function,
            },
            UserId:{
                type:String
            }
},
        components: {
       Skeleton,
       ProductCard,
        },
        data() {
            return {
                NotProductImg: NotProductImg,
               
            }
        },
        computed: {
            userId() {
                return localStorage.getItem('id_user')
            }
        },
        methods: {
              ...mapActions('product_list',['ActionGetProduct']),
            formatN (price) {
                return formatPrice(price)
            }
        },
        created () {

        },

    }
</script>

<style lang="css" scoped>
.minH{
    min-height: 6.422rem;
}

.text-uppercase {
    text-transform: uppercase !important;
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 1.1rem;
    line-height: 1.3rem;
    /* identical to box height */

    text-align: left;
    text-transform: capitalize;

    color: #921914;
}

</style>